<template>
<div>
    <MeuLocal/>
    <div class="my-8">
        <MinhaConta/>
    </div>
    <AlterarSenha/>
</div>
</template>
<script>
import MeuLocal from './MeuLocal'
import MinhaConta from './MinhaConta'
import AlterarSenha from './AlterarSenha'
export default{
    components:{MeuLocal,MinhaConta,AlterarSenha},
    name:'PerfilLocal',
    data:()=>({

    })
}
</script>